'use strict';
var parent = require('../../stable/object/get-own-property-names');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/get-own-property-names.js
// module id = 546
// module chunks = 13